export default kendo.Layout.extend({

    init: function(template, options) {
        kendo.Layout.fn.init.apply(this, arguments);
        this.bind("show", function() {
            $("html, body, #viewport, #module").toggleClass("scroll-view", !!options.shouldContainerScroll).toggleClass("full-view", !options.shouldContainerScroll);
        });

        this._destroyGlobal = options ? options.destroyGlobal : false;

    },

    destroy: function() {
        kendo.Layout.fn.destroy.apply(this, arguments);
        if (this._destroyGlobal) {
            var idSelector = "[id^='" + this._destroyGlobal + "_']";
            kendo.destroy($(".k-window [data-role='popupwindow']").filter(idSelector));
            kendo.destroy($("[data-role='dfcontextmenu']").filter(idSelector));
        }
    },

    hide: function() {
        kendo.View.fn.hide.apply(this, arguments);

        /**
         * If a button or link causes the view to change blur and mouseout do not always get called
         * on that button.  This ensures that the relevant styles still get removed.
         */

        this.element.find(".k-state-focused").removeClass("k-state-focused");
        this.element.find(".k-state-hover").removeClass("k-state-hover");
    }
});
